import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion";
import { getMonthlyRevenueTrend, getRevenueDistribution, getStatsData } from '../utils/helperFunctions';
import { Line } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const Superadmindashboard = () => {
    const [stats, setStats] = useState({});
    const [range, setRange] = useState('6m');
    const [selectedRange, setSelectedRange] = useState('current_month');
    const [chartData, setChartData] = useState({ labels: [], dataPoints: [] });
    const [revenueData, setRevenueData] = useState({ labels: [], data: [] });


    useEffect(() => {
        fetchStats();
    }, []);
    useEffect(() => {
        fetchTrendData();
    }, [range]);
    useEffect(() => {
        fetchRevenueDistribution();
    }, [selectedRange]);

    const fetchStats = async () => {
        try {
            const response = await getStatsData();
            if (response.status) {
                setStats(response.data);
            }
        } catch (error) {
            console.error('Error fetching stats:', error);
        }
    };

    const fetchTrendData = async () => {
        try {
            const res = await getMonthlyRevenueTrend(range);
            setChartData({
                labels: res.data.labels,
                dataPoints: res.data.data
            });
        } catch (err) {
            console.error('Failed to fetch trend data', err);
        }
    };

    const fetchRevenueDistribution = async () => {
        try {
            const response = await getRevenueDistribution(selectedRange);
            if (response.status) {
                const labels = response.data.labels;
                const data = response.data.data;
                setRevenueData({ labels, data });
            }
        } catch (err) {
            console.error('Failed to fetch trend data', err);
        }
    };



    return (
        <div className="p-4 md:p-6 bg-gray-50 ">
            <div className="container mx-auto bg-white rounded-xl shadow-sm overflow-hidden">
                <div className="p-4 md:p-6 border-b border-gray-100 bg-gradient-to-r from-indigo-50 to-blue-50">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4">
                        <div>
                            <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Super Admin Dashboard</h1>
                            <p className="text-sm text-gray-600 mt-1">Complete overview of all hotels and users</p>
                        </div>

                    </div>


                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
                        >
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Total Hotels</p>
                                    <p className="text-2xl font-bold text-gray-800 mt-1">
                                        {stats.totalHotels}
                                    </p>

                                </div>
                                <div className="bg-indigo-100 p-3 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                    </svg>
                                </div>
                            </div>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: 0.1 }}
                            className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
                        >
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Users</p>
                                    <p className="text-2xl font-bold text-gray-800 mt-1">
                                        {stats.totalUsers}
                                    </p>
                                    <div className="grid grid-cols-2 gap-1 mt-2 text-xs text-gray-500">
                                        <div className="flex items-center">
                                            <div className="w-2 h-2 rounded-full bg-purple-500 mr-1"></div>
                                            <span>Managers: {stats.totalManagers}</span>
                                        </div>
                                        <div className="flex items-center">
                                            <div className="w-2 h-2 rounded-full bg-pink-500 mr-1"></div>
                                            <span>Receptionists: {stats.totalReceptionists}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-blue-100 p-3 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                    </svg>
                                </div>
                            </div>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: 0.2 }}
                            className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
                        >
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Monthly Revenue</p>
                                    <p className="text-2xl font-bold text-gray-800 mt-1">
                                        ₹{stats.totalRevenueCurrentMonth?.toLocaleString()}
                                    </p>
                                    <div className="flex items-center mt-2 text-xs text-gray-500">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-green-500 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
                                        </svg>
                                        <span>Current month</span>
                                    </div>
                                </div>
                                <div className="bg-green-100 p-3 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3, delay: 0.3 }}
                            className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
                        >
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Current Occupancy</p>
                                    <p className="text-2xl font-bold text-gray-800 mt-1">
                                        {stats.activeGuestsCurrentMonth}
                                        <span className="text-sm font-normal ml-1">guests</span>
                                    </p>
                                    <div className="flex items-center mt-2 text-xs text-gray-500">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-blue-500 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clipRule="evenodd" />
                                        </svg>
                                        <span>Active this month</span>
                                    </div>
                                </div>
                                <div className="bg-blue-100 p-3 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>


                <div className="p-4 md:p-6 grid grid-cols-1 lg:grid-cols-2 gap-6">

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm"
                    >
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold text-gray-800">Revenue Trend</h2>
                            <div className="flex items-center gap-2">
                                <select
                                    className="text-xs border border-gray-200 rounded-md px-2 py-1 bg-gray-50 outline-none"
                                    value={range}
                                    onChange={(e) => setRange(e.target.value)}
                                >
                                    <option value="6m">Last 6 Months</option>
                                    <option value="1y">Last Year</option>
                                    <option value="5y">Last 5 Year</option>
                                </select>
                            </div>
                        </div>
                        <div className="h-64">
                            <Line
                                data={{
                                    labels: chartData.labels,
                                    datasets: [
                                        {
                                            label: 'Revenue',
                                            data: chartData.dataPoints,
                                            borderColor: 'rgb(79, 70, 229)',
                                            backgroundColor: 'rgba(79, 70, 229, 0.5)',
                                            tension: 0.1
                                        }
                                    ]
                                }}
                                options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                        y: {
                                            beginAtZero: true,
                                            grid: { color: '#f3f4f6' },
                                            ticks: {
                                                callback: function (value) {
                                                    return '₹' + value.toLocaleString();
                                                }
                                            }
                                        },
                                        x: { grid: { display: false } }
                                    },
                                    plugins: {
                                        tooltip: {
                                            callbacks: {
                                                label: function (context) {
                                                    return '₹' + context.parsed.y.toLocaleString();
                                                }
                                            }
                                        },
                                        legend: {
                                            display: false
                                        },
                                    }
                                }}
                            />
                        </div>
                    </motion.div>


                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: 0.1 }}
                        className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm"
                    >
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold text-gray-800">Top 10 Hotel contribution</h2>
                            <div className="flex items-center gap-2">
                                <select
                                    className="text-xs border border-gray-200 rounded-md px-2 py-1 bg-gray-50 outline-none"
                                    value={selectedRange}
                                    onChange={(e) => setSelectedRange(e.target.value)}
                                >
                                    <option value="current_month">Current Month</option>
                                    <option value="last_month">Last Month</option>
                                    <option value="last_6_months">Last 6 Months</option>
                                </select>
                            </div>
                        </div>
                        <div className="h-64 flex items-center justify-center">
                            <Bar
                                data={{
                                    labels: revenueData.labels,
                                    datasets: [
                                        {
                                            label: 'Hotel Revenue',
                                            data: revenueData.data,
                                            backgroundColor: [
                                                'rgba(79, 70, 229, 0.7)',
                                                'rgba(16, 185, 129, 0.7)',
                                                'rgba(245, 158, 11, 0.7)',
                                                'rgba(239, 68, 68, 0.7)',
                                                'rgba(34, 197, 94, 0.7)',
                                                'rgba(59, 130, 246, 0.7)'
                                            ],
                                            borderColor: [
                                                'rgba(79, 70, 229, 1)',
                                                'rgba(16, 185, 129, 1)',
                                                'rgba(245, 158, 11, 1)',
                                                'rgba(239, 68, 68, 1)',
                                                'rgba(34, 197, 94, 1)',
                                                'rgba(59, 130, 246, 1)'
                                            ],
                                            borderWidth: 1
                                        }
                                    ]
                                }}
                                options={{
                                    indexAxis: 'y',
                                    maintainAspectRatio: false,
                                    responsive: true,
                                    scales: {
                                        x: {
                                            beginAtZero: true,
                                            ticks: {
                                                callback: function (value) {
                                                    return value.toLocaleString();
                                                }
                                            }
                                        },
                                        y: {
                                            grid: {
                                                display: false
                                            }
                                        }
                                    },
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: function (context) {
                                                    const label = context.dataset.label || '';
                                                    const value = context.raw || 0;
                                                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                                                    const percentage = ((value / total) * 100).toFixed(2);
                                                    return `${label}: ${value.toLocaleString()} (${percentage}%)`;
                                                }
                                            }
                                        }
                                    }
                                }}
                            />
                        </div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
}

export default Superadmindashboard
